/**
 * Lightweight logger — silent in production builds.
 *
 * Use this instead of raw `console.*` so warnings/errors aid debugging in
 * development but never ship in the production bundle (no log spam, no
 * accidental leakage of caught error stacks).
 */
const isDev = process.env.NODE_ENV !== "production";

export const log = {
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
};
